import { useSelector } from "react-redux";
import clsx from "clsx";
import {
  FormControlLabel,
  Typography,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import { palette } from "../../../theme/palette";
import { FULL_DAYS, NONE } from "../../../consts/strings";

import { View } from "../../View";
import { getUserMetadata } from "../../../reducers/ownUser/selectors";

const useStyles = makeStyles({
  container: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  topContainer: {
    display: "flex",
    padding: "1rem 2.5rem",
    gap: "2rem",
  },
  bottomContainer: {
    display: "flex",
    flexDirection: "column",
    padding: "0rem 0.5rem",
    margin: "1rem 0rem 2rem 2rem",
  },
  column: {
    display: "flex",
    flexDirection: "column",
    width: "8rem",
    gap: "1rem",
  },
  header: {
    marginLeft: "0.75rem",
  },
  dropDown: {
    width: "100%",
  },
  dropDownErrorHelper: {
    marginRight: "5px",
    marginBottom: "-3%",
  },
  formCheckbox: { paddingLeft: "0.5rem" },
  formCheckboxLabel: {
    color: palette.grey,
    fontSize: "13px",
  },
});

export const ShiftManagerManagementModalContent = ({
  sections,
  shiftManager,
  onChange,
  disabled,
  errors,
}) => {
  const styles = useStyles();
  const { user } = useSelector(getUserMetadata);
  const { shiftManagerCode, restrictedAccess } = shiftManager;
  const isDisabled =
    disabled || (restrictedAccess && shiftManagerCode === user.user_id);

  return (
    <View className={styles.container}>
      <View className={styles.topContainer}>
        {shiftManager.sections.map(({ dayOfWeek, sectionCode }) => (
          <View className={styles.column}>
            <View className={styles.header}>{FULL_DAYS[dayOfWeek]}</View>
            <FormControl className={styles.dropDown} variant={"outlined"}>
              <InputLabel
                id="section"
                error={!!errors[`${dayOfWeek}-sectionCode`]}
              >
                Section
              </InputLabel>
              <Select
                label={"Section"}
                labelId={"section"}
                name={"sectionCode"}
                value={sectionCode || 0}
                disabled={isDisabled}
                error={!!errors[`${dayOfWeek}-sectionCode`]}
                onChange={(e) => {
                  onChange({
                    ...e,
                    target: {
                      ...e.target,
                      dayOfWeek,
                    },
                  });
                }}
              >
                {[
                  <MenuItem key={NONE} value={0}>
                    {NONE}
                  </MenuItem>,
                  ...sections.map(({ sectionCode, sectionName }) => (
                    <MenuItem key={sectionCode} value={sectionCode}>
                      {sectionName}
                    </MenuItem>
                  )),
                ]}
              </Select>
              <FormHelperText
                className={clsx(
                  !!errors[`${dayOfWeek}-sectionCode`] &&
                    styles.dropDownErrorHelper
                )}
                error={!!errors[`${dayOfWeek}-sectionCode`]}
              >
                {errors[`${dayOfWeek}-sectionCode`] || ""}
              </FormHelperText>
            </FormControl>
          </View>
        ))}
      </View>
      <View className={styles.bottomContainer}>
        <FormControlLabel
          className={styles.formCheckbox}
          control={
            <Checkbox
              color={"default"}
              checked={shiftManager["restrictedAccess"]}
              name={"restrictedAccess"}
              onChange={(e) =>
                onChange({
                  ...e,
                  target: {
                    ...e.target,
                    name: "restrictedAccess",
                    value: !!e.target.checked,
                  },
                })
              }
              disabled={isDisabled || shiftManagerCode === user.user_id}
            />
          }
          label={
            <Typography className={styles.formCheckboxLabel}>
              Locked to section
            </Typography>
          }
        />
      </View>
    </View>
  );
};
